import { UserDto } from 'src/app/generated/backend/models';

// Authentication stage across the login flow
export enum AuthStage {
  Anonymous = 'anonymous',
  Password = 'password',
  TwoFactor = 'twoFactor',
  Authenticated = 'authenticated',
}

export interface UserStateModel {
  loading: boolean;
  error: boolean;
  user: UserDto | null;
  authStage: AuthStage;
  // Temporarily hold credentials between password and 2FA steps (not persisted)
  pendingName?: string | null;
  pendingPassword?: string | null;
}
